module.exports = __webpack_public_path__ + "img/wifi2.0f6f33ba.png";